<template>
  <div class="support" :style="{ 'min-height': clientHeight + 'px' }">
    <div class="support-header">
      <div class="header-content">
        <h2 class="title">
          <router-link to="/en/support" class="link">{{
            $t("m.sedNav.supportTitle")
          }}</router-link>
          <span class="support-text-addon">
            <span class="arrow">&gt;</span>
            <span class="support-current-breadcrumb">{{
              $t("m.sedNav.content")
            }}</span>
          </span>
        </h2>
        <div class="search">
          <span class="support-input">
            <input
              type="text"
              class="support-ipt"
              :placeholder="$t('m.sedNav.search')"
              v-model="searchinpt"
              @keydown.enter="search()"
          /></span>
          <span class="search-icon"> </span>
        </div>
      </div>
    </div>
    <div class="support-content">
      <FreqWithBtn></FreqWithBtn>
    </div>
  </div>
</template>

<script>
import i18n from "../lang";
import { useRouter } from "vue-router";

import FreqWithBtn from "../components/FreqWithBtn.vue";
export default {
  components: { FreqWithBtn },
  setup() {
    return {
      contentTitle: useRouter().currentRoute.value.query.title,
      lang: useRouter().currentRoute.value.query.lang,
    };
  },
  data() {
    return {
      //可视区域高度
      clientHeight: "",
      searchinpt: "",
      content: [],
      list: [
        {
          title: "The 3D movie seems a bit off, what can I do?",
          detail:
            "First, you can adjust the “3D Offset” in the “Advanced Settings” to have a more comfortable view.<br />Second, if you want to disable 3D experience, you can select “Monoscopic” in the “Advanced Settings” which allows you to see the same picture in both eyes.",
        },
        {
          title:
            "When I call up the control panel while watching 3D video, the image seems much clearer?",
          detail:
            "When the control panel is called out, SKYBOX will let the left and right eyes display the same picture.<br /><br />When playing 3D videos, different clips have different focus distances. Meanwhile, the control panel is a two-dimensionally simulated parallax stereo vision, not real 3D experience. You will have a hard time focusing on the control panel if we keep the 3D effect.",
        },
        {
          title:
            "Does SKYBOX support Youtube 180 (Fisheye) and Youtube 360 (EAC)?",
          detail:
            "Yes!<br />When you play a Youtube 180 or Youtube 360 video, click on the “Stereo Mode” on the right side of control panel and select Fisheye or Youtube. Then you will enjoy your videos in the right format.",
        },
        {
          title: "Why the ongoing AirScreen video sometimes buffering?",
          detail:
            "Maybe that’s because of the network environment, usually 2.4G Wi-Fi signal will be slower than 5G Wi-Fi transmission, and there will be more interference. So we recommend using 5G Wi-Fi routing connection as much as possible.",
        },
        {
          title:
            "After establishing the connection of PC Client and mobile phone, can I use the phone to control VR content?",
          detail:
            "Yes, the AirScreen function allows you to control the contents on PC client. You can make switches, play, pause, switch VR stereo mode and other control actions both on PC Client and VR device, and all these operations will response simultaneously in SKYBOX VR Player.",
        },
        {
          title:
            "Can I connect multiple mobile VR devices to a PC client to play video?",
          detail:
            "Yes, at the moment we support 3-5 devices connected and play video at the same time. The number of connected devices depends on the performance of your PC and the local network environment, so we recommend the use of 5G Wi-Fi connection.",
        },
        {
          title: "How can I change the display name of my PC on AirScreen?",
          detail:
            "Launch PC Client on your PC, click on the Settings (gear icon) on the right upper corner and edit your Device ID.",
        },
        {
          title: "Can I delete videos on a SMB share?",
          detail:
            "No, you cannot delete videos on a SMB share.<br /><br />This is technically not possible right now because we need to find a universal solution for all the different ports which SMB runs on.<br /><br />Please be patient with us 🙂",
        },
        {
          title: "What’s the different between Hidden Files and Hide Folder?",
          detail:
            "There are two kinds of hiding in SKYBOX:<br /><br />1. The “Hide” folder is an actual folder in the directory that is used to hide files from apps other than SKYBOX. So that the files in the Hide Folder can only show in SKYBOX. You have access to it when you plug your device into a PC.<br /><br />2. The “Hidden Files” are the files you want to hide inside of SKYBOX. This aims to provide a personalized and private playlist which you can keep it to yourself (with a 4-digit password protection). The way to use Hidden Files is as following:<br /><br />(1) Open the folder in which contains the files you want to hide.<br />(2) Click on the upper right side menu on the files interface, and click on “Hide Current Folder.”<br />(3) You can hide more files/folders.<br />(4) To hide/show all hidden files/folders, click on the upper right side menu and turn on/off the switch “Show Hidden Folders”. You will need to input a 4-digit password the first time you turn off the switch. This makes sure that your hidden files are protected.<br />(5) Hidden files will disappear from all history/collection.",
        },
        {
          title: "How to forget SMB username and password?",
          detail:
            "There are two ways to forget SMB username and password:<br /><br />1. Connect your device to PC and find the file which containing the encrypted SMB username and password: Android/Data/xyz.skybox.player/Files/PersistentData/FileDelete this file and you will be able to re-login the SMB.<br /><br />2. When you access to one SMB share folder, click on the wrench on the right upper corner and there is an option to log-out the SMB folder. Click on this option and next time you access to this SMB you will be requested to input username and password.",
        },
        {
          title: "How can I add videos to “Favorite” list?",
          detail:
            "Play the video you like and call up the control panel, click on the “heart” icon then the video is added to the “Favorite” list.",
        },
        {
          title: "How can I delete videos?",
          detail:
            "Simply click on the wrench icon on the right upper corner of the menu and select “Delete Files”.<br />Attention: you can only delete videos stored in your device.",
        },
        {
          title: "Add suffix to help recognize the correct format",
          detail:
            "The following rules apply to SKYBOX versions across all platforms after SKYBOX V0.2.3.4.<br /><br />3D format<br />3dv, TB, Top + Bottom, OU, Over + Under, HOU, Half + OU, Half + Over + Under<br />3dh, LR, Left + Right, SBS, Side + By + Side, HSBS, Half + SBS, Half + Side + By + Side<br /><br />Angles<br />360, 360°, 180×180, 180°<br /><br />Fisheye aka Youtube 180<br />F180, VR180<br /><br />EAC aka Youtube 360<br />EAC360<br /><br />The ‘+’ sign could be replaced by one space or any sign or nothing.<br />You do not have to worry about the order of the two information or capitalization.<br />The default setting is 2D normal movie (2d screen).<br /><br />Some examples:<br />moviename.mp4 (2d screen)<br />moviename_360.mp4 (2D 360)<br />moviename_360_TB.mp4 (3D-topbottom 360)<br />moviename_180x180_Side-By-Side.mp4 (3D-sidebyside 360)<br />moviename_EAC360.mp4 (2d EAC)<br />moviename_F180_OU.mp4 (3D-topbottom Fisheye)<br /><br />Enjoy 🙂",
        },
        {
          title: "Why can’t my video play?",
          detail:
            "(1) SKYBOX VR player supports almost all common video formats such as mp4/mkv/mov/avi/wmv/rmvb/flv. If the video you imported could not be recognized, please check whether the video is in a special format.<br /><br />(2) Please check whether the video file is damaged, check whether the size of the video you downloaded is complete and as same as described before downloading.",
        },
        {
          title: "Why SKYBOX is not compatible with my Android phone?",
          detail:
            "SKYBOX VR Video Player is a VR experience and can be only used with a VR headset.<br /><br />For Android users, please check whether your device is a daydream-ready phone: 'https://vr.google.com/daydream/smartphonevr/phones/' <br /><br />ATTENTION for Samsung Note 8 users:<br /><br />If your device uses Samsung Exynos 8895 chip, then SKYBOX is not compatible.<br /><br />In our latest updates (0.1.7 and after) in Daydream, we used the Unity 2017 SDK, which is known to have serious compatibility issues with Daydream on this chip.<br /><br />We hope Unity can fix this ASAP and we can only wait until Unity fixes the bug.<br /><br />Please use Gear VR for SKYBOX in the meantime.<br /><br />Sorry for the inconvenience and thank you for understanding 🙂",
        },
        {
          title: "为什么使用 AirScreen 播放视频时会有些卡顿？",
          detail:
            "可能是由于网络环境原因，通常情况下 2.4G Wi-Fi 信号会比 5G Wi-Fi 的传输速度更慢，以及会有更多的干扰。所以我们推荐尽可能使用 5G Wi-Fi 路由进行连接。",
        },
        {
          title:
            "PC 客户端和 VR 设备建立连接后是否可以通过 VR 控制 PC 上的内容？",
          detail:
            "可以，AirScreen 功能允许你使用 VR 设备 控制 PC 客户端上的内容。你可以同时在 VR 设备和 PC 客户端上进行切换、播放、暂停、切换 VR 立体模式等操作，所有操作都会在 SKYBOX VR 播放器内同步响应。",
        },
        {
          title: "我可以将多台 VR设备 连接到同一个 PC 客户端吗？",
          detail:
            "可以，目前我们支持 3-5 台设备同时连接和播放。连接设备的数量取决于你的 PC 性能以及局域网环境，所以我们推荐使用 5G Wi-Fi 进行连接。",
        },
        {
          title: "如何区分隐藏文件与私密文件夹？",
          detail:
            "SKYBOX为用户提供两种隐私设置，分别为隐藏文件与私密文件夹。<br /><br />私密文件夹是一个实体文件夹，放入其中的文件不会被除SKYBOX以外的其他应用识别。当你将VR设备与电脑连接时，你可以编辑这个文件夹的内容。<br /><br />隐藏文件是可以在SKYBOX内部隐藏的文件（其是被选中的现存文档，而不是一个独立的实体文件夹）。如需使用隐藏文件，请按以下步骤操作：<br /><br />（1）打开你想要隐藏的文件所在文件夹。<br />（2）点击文件界面右上角的菜单，然后点击“隐藏此文件夹”。<br />（3）你可以选择更多的文件/文件夹进行隐藏。<br />（4）如果需要隐藏/显示所有的隐藏文件/文件夹，点击右上角菜单并打开/关闭“显示隐藏文件”按钮。<br />（5）隐藏文件将会从历史记录/收藏中消失。",
        },
        {
          title: "为什么我的视频无法播放？",
          detail:
            "（1）SKYBOX VR 播放器支持所有主流视频格式如 mp4/mkv/mov/avi/wmv/rmvb/flv 等。如果你导入的视频无法播放，请检查视频是否属于特殊格式。<br /><br />（2）请检查视频文件是否损坏，检查你所下载的视频大小是否完整，和下载前所描述的是否一致。",
        },
      ],
      tital: "",
      detail: "",
    };
  },
  created() {
    this.showContent();
  },
  mounted() {
    // 获取浏览器可视区域高度
    this.clientHeight = `${document.documentElement.clientHeight}` - 104; //document.body.clientWidth;
    zE("webWidget", "hide");
    if (this.lang == "zh") {
      i18n.global.locale = "zh";
    } else {
      i18n.global.locale = "en";
    }
  },
  methods: {
    showContent() {
      this.list.map((item) => {
        if (item.title.indexOf(this.contentTitle) != -1) {
          this.content.push(item);
        }
      });
    },
    search() {
      if (this.$i18n.t("m.lang") == "en") {
        this.$router.push({
          path: "/search",
          query: { search: this.searchinpt },
        });
      } else {
        this.$router.push({
          path: "/search-zh",
          query: { search: this.searchinpt },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
//部分样式与support公用
@import "../assets/scss/content.scss";
@import "../assets/scss/support.scss";
</style>